import script from "./CardPaymentSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPaymentSettings.vue?vue&type=script&setup=true&lang=js"

import "./CardPaymentSettings.vue?vue&type=style&index=0&id=3cd71cb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cd71cb6"]])

export default __exports__